import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { nodeEventFailed, nodeEventSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* nodeEvent(action) {
  try {
    const {
      id,
      unpause,
    } = action.payload;
    const url = `${BACKEND_URL}/${unpause ? 'unpause' : 'pause'}-node/${id}`;
    const dataResponse = yield makeRequest(url, {}, action, 'POST', true);
    if (dataResponse.status === OK) {
      yield put(nodeEventSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(nodeEventFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(nodeEventFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
